import { AfterViewInit, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ApprovalFlowStep } from '@app/components/approval-status-flow/approval-status-flow.component';
import { ApprovalWorkflowService, AuthService } from '@app/services';
import ChangeRequestFlowStep from '@change-requests/classes/change-request-flow-step.class';
import { ChangeRequestStepStatus } from '@change-requests/enums/change-request-step-status.enum';
import { PreviewStep } from '@change-requests/interfaces';
import { ChangeRequestTemplate } from '@models/change-requests/change-request-template.model';
import { Employee } from '@models/employee/employee.model';

@Component({
    selector: 'change-request-approval-preview',
    templateUrl: './change-request-approval-preview.template.html',
    styleUrls: ['./change-request-approval-preview.style.scss'],
})
export class ChangeRequestApprovalPreviewComponent implements AfterViewInit, OnChanges {
    @Input() effectiveAtDate: string;
    @Input() subject: Employee;
    @Input() changeRequestTemplate: ChangeRequestTemplate;
    approvalFlowSteps: ApprovalFlowStep[] = [];
    previewSteps: PreviewStep[] = [];

    constructor(
        private approvalWorkflowService: ApprovalWorkflowService,
        private auth: AuthService
    ) {}

    async ngAfterViewInit(): Promise<void> {
        this.previewSteps = await this.approvalWorkflowService.getPreviewSteps(
            this.changeRequestTemplate.approvalWorkflow,
            this.subject
        );

        this.getApprovalFlowSteps();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.effectiveAtDate) {
            this.getApprovalFlowSteps();
        }
    }

    getApprovalFlowSteps(): void {
        let changeRequestFlowSteps = this.previewSteps.map(
            (step) => new ChangeRequestFlowStep(step.full_name, ChangeRequestStepStatus.Pending, this.auth)
        );

        changeRequestFlowSteps = this.addSubmittedStep(changeRequestFlowSteps);
        changeRequestFlowSteps = this.addEffectiveAtStep(changeRequestFlowSteps);

        this.approvalFlowSteps = this.covertToApprovalFlowSteps(changeRequestFlowSteps);
    }

    private addSubmittedStep(changeRequestFlowSteps: ChangeRequestFlowStep[]): ChangeRequestFlowStep[] {
        const submittedStep = new ChangeRequestFlowStep(null, ChangeRequestStepStatus.Submitted, this.auth);

        return [submittedStep, ...changeRequestFlowSteps];
    }

    private addEffectiveAtStep(changeRequestFlowSteps: ChangeRequestFlowStep[]): ChangeRequestFlowStep[] {
        const effectiveStep = new ChangeRequestFlowStep(
            this.subject,
            ChangeRequestStepStatus.EffectiveAt,
            this.auth,
            this.effectiveAtDate
        );

        return [...changeRequestFlowSteps, effectiveStep];
    }

    private covertToApprovalFlowSteps(ChangeRequestFlowSteps: ChangeRequestFlowStep[]): ApprovalFlowStep[] {
        return ChangeRequestFlowSteps.map((step) => {
            return {
                title: step.title,
                description: step.description,
                status: step.componentStatus,
                hideIndicator: false,
            };
        });
    }
}
